// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-size: 0.875rem;
}
/*
  ------------------------------------------------- INICIO DOS ELEMENTOS PADRÕES -------------------------------------------------
*/
hr {
  opacity: 0.2;
  border: 0;
  border-top: 0.063rem solid black;
}
h1,
h2,
h3,
h4,
h5,
h6,
p {
  color: #000000;
}
h1 {
  font-size: 2.375rem;
  font-weight: 300;
  line-height: 2.38rem;
  white-space: pre-line;
}
@media (max-width: 768px) {
  h1 {
    font-size: 1.5rem;
    line-height: 1.6rem;
  }
}
h2 {
  font-size: 2rem;
  font-weight: 300;
  line-height: 2.5rem;
  white-space: pre-line;
}
@media (max-width: 768px) {
  h2 {
    font-size: 1.5rem;
    line-height: 1.6rem;
  }
}
h3 {
  font-size: 1.75rem;
  font-weight: 300;
  line-height: 2.1rem;
  white-space: pre-line;
}
@media (max-width: 768px) {
  h3 {
    font-size: 1.25rem;
    line-height: 1.3rem;
  }
}
h4 {
  font-size: 1.5rem;
  font-weight: 300;
  line-height: 1.8rem;
  white-space: pre-line;
}
@media (max-width: 768px) {
  h4 {
    font-size: 1.25rem;
    line-height: 1.5rem;
  }
}
h5 {
  font-size: 1.25rem;
  font-weight: 300;
  line-height: 1.5rem;
}
@media (max-width: 768px) {
  h5 {
    font-size: 1rem;
    line-height: 1.3rem;
  }
}
h6 {
  font-size: 1.125rem;
  font-weight: 300;
  line-height: 1.3rem;
}
@media (max-width: 768px) {
  h6 {
    font-size: 1rem;
    line-height: 1rem;
  }
}
p {
  font-size: 1rem;
  font-weight: 200;
  line-height: 1.375rem;
}
b {
  color: #000000;
  font-weight: 400;
}
b.weight-500 {
  font-weight: 500 !important;
}
a {
  color: var(--link-button-color);
  text-decoration: underline;
  font-weight: 500;
}
a:hover {
  color: var(--link-button-color);
}
strong {
  color: #000000;
  font-weight: 600;
}
.primary-text {
  color: var(--primary-color) !important;
}
.secondary-text {
  color: var(--primary-button-color) !important;
}
.link-text {
  color: var(--link-button-color) !important;
}
.justified-text {
  text-align: justify;
}
.center-text {
  text-align: center;
}
.left-text {
  text-align: left;
}
.right-text {
  text-align: right;
}
.white-text {
  color: #ffffff;
}
.gray-text {
  color: #C9D3CC;
}
.white-label-text {
  color: var(--primary-text-color);
}
.success-text {
  color: var(--success-color);
}
.warning-text {
  color: var(--warning-color);
}
.danger-text {
  color: var(--danger-color);
}
.primary-button-text {
  color: var(--primary-button-text-color);
  font-weight: 500;
}
.secondary-button-text {
  color: var(--secondary-button-text-color);
  font-weight: 500;
}
.underline {
  text-decoration: underline;
}
.no-margin-bottom {
  margin-bottom: 0;
}
.no-margin {
  margin: 0 !important;
}
.no-padding {
  padding: 0 !important;
}
/*
  ------------------------------------------------- FIM DOS ELEMENTOS PADRÕES -------------------------------------------------
*/
/*
  ------------------------------------------------- INICIO DOS ELEMENTOS ANTD -------------------------------------------------
*/
.ant-card {
  border: 1px solid #C9D3CC;
  box-shadow: none;
  border-radius: 1.25rem;
  padding: 2.5rem 5rem;
}
.ant-card .ant-card-body {
  padding: 0;
  margin: 0;
}
@media (max-width: 992px) {
  .ant-card {
    padding: 2rem 3rem;
  }
}
@media (max-width: 768px) {
  .ant-card {
    padding: 1.5rem;
  }
}
.ant-notification {
  z-index: 5000000001;
}
.ant-notification .ant-notification-notice {
  width: 28.625rem;
  box-shadow: 0rem 0.25rem 0.25rem rgba(0, 0, 0, 0.05);
  border: 0.063rem solid #C9D3CC;
  border-radius: 1.25rem;
}
.ant-notification .ant-notification-notice .ant-notification-close-icon {
  color: black;
}
.ant-notification .ant-notification-notice .ant-notification-notice-message {
  font-weight: 300;
  color: #000000;
  font-size: 1.125rem;
  line-height: 1.5rem;
}
.ant-notification .ant-notification-notice .ant-notification-notice-description {
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.375rem;
}
@media (max-width: 768px) {
  .ant-form .ant-form-item {
    margin-bottom: 1.5rem;
  }
}
/*
------------------------------------------------- FIM DOS ELEMENTOS ANTD -------------------------------------------------
*/
/*
------------------------------------------------- INÍCIO DA TERRA DOS SEM LEI -------------------------------------------------
*/
.ant-checkbox:hover span {
  border: 0.063rem solid var(--primary-button-color) !important;
  opacity: 1;
}
.ant-checkbox + span {
  padding-left: 0.71rem;
  padding-right: 0;
}
.ant-checkbox.ant-checkbox-checked .ant-checkbox-inner {
  border-color: var(--primary-button-color) !important;
  background-color: var(--primary-button-color) !important;
}
.ant-checkbox::after {
  border-color: transparent;
}
.ant-checkbox .ant-checkbox-input:focus + .ant-checkbox-inner {
  border-color: var(--primary-button-color);
}
.ant-checkbox-wrapper:hover .ant-checkbox-inner {
  border-color: var(--primary-button-color);
}
.ant-form-item-label label {
  color: var(--primary-color);
  opacity: 1;
}
.ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
  content: none;
}
.ant-form-item-label > label::after {
  content: none;
}
#root {
  height: 100%;
}
section.ant-layout {
  background-color: #ffffff !important;
}
.ant-popover-inner {
  border-radius: calc(1.25rem / 2);
  box-shadow: 0rem 0.5rem 0.938rem rgba(0, 0, 0, 0.15);
}
.ant-popover-inner .ant-popover-inner-content {
  padding: 0 !important;
}
.ant-popover-inner .ant-menu-title-content {
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.2rem;
  color: #003930;
}
.ant-drawer-header {
  border-bottom: none;
  padding: 0.5rem 4rem;
}
.ant-drawer-header .close-icon {
  margin-right: 0.5rem;
}
@media (max-width: 768px) {
  .ant-drawer-header {
    padding: 0.5rem 1rem;
  }
}
.ant-drawer-body {
  padding: 0;
}
.ant-drawer-footer {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 4rem;
}
.ant-drawer-footer .back-icon {
  margin-right: 0.5rem;
}
.ant-drawer-footer .gyramais-btn {
  min-width: 30%;
}
.ant-drawer-footer .gyramais-btn.gyramais-btn-link {
  min-width: 1rem;
}
@media (max-width: 768px) {
  .ant-drawer-footer {
    padding: 0.5rem 1rem;
  }
}
.ant-input-number {
  padding: 0.25rem 0.688rem;
}
a:hover {
  cursor: pointer;
  text-decoration: underline !important;
}
.ant-drawer .ant-drawer-content-wrapper {
  max-width: 66.25rem;
}
@media (min-width: 150rem) {
  .ant-drawer:not(.mobile-menu) .ant-drawer-content-wrapper {
    width: 50% !important;
  }
}
@media (max-width: 768px) {
  .ant-drawer:not(.mobile-menu) .ant-drawer-content-wrapper {
    width: 100% !important;
  }
}
.ant-checkbox-inner {
  border-color: #00000044;
}
.ant-checkbox-checked .ant-checkbox-inner {
  background-color: var(--primary-button-color) !important;
}
.react-share__ShareButton {
  outline: none !important;
}
.ant-tabs-nav-list .ant-tabs-tab {
  font-size: 1rem;
  line-height: 1.375rem;
  font-weight: 400;
}
.ant-tabs-nav-list .ant-tabs-tab:not(.ant-tabs-tab-disabled):hover .ant-tabs-tab-btn {
  color: #000000;
}
.ant-tabs-nav-list .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #000000;
}
.ant-tabs-nav-list .ant-tabs-ink-bar {
  height: 0.25rem !important;
  background: var(--primary-button-color) !important;
}
.ant-alert {
  border-radius: 0.625rem;
}
.ant-alert .ant-alert-message {
  font-weight: 400;
  font-size: 1rem;
}
.grey-alert {
  background-color: #f0f0f0 !important;
  border-color: #f0f0f0 !important;
  margin-bottom: 0.75rem !important;
}
.grey-alert span.ant-alert-message {
  opacity: 0.5;
}
.grey-alert .alert-icon {
  color: #000000 !important;
}
.ant-image {
  cursor: pointer;
}
.ant-table-content,
.ant-table-container {
  margin-right: 0 !important;
}
.ant-table-content td,
.ant-table-container td {
  font-size: 1.5rem;
  line-height: 1.75rem;
}
.ant-table-content .ant-table-thead tr th,
.ant-table-container .ant-table-thead tr th {
  background: white !important;
  background-color: white;
  color: var(--primary-button-color) !important;
  border: none;
  padding-bottom: 0;
  font-weight: normal !important;
  font-size: 1.125rem;
}
.ant-table-content .ant-table-thead tr th .ant-table-column-sorters > span:first-of-type,
.ant-table-container .ant-table-thead tr th .ant-table-column-sorters > span:first-of-type {
  font-weight: normal !important;
  font-size: 1.125rem;
}
.ant-table-content .ant-table-thead tr th .ant-table-column-sorter,
.ant-table-container .ant-table-thead tr th .ant-table-column-sorter {
  display: flex;
}
.ant-table-content .ant-table-thead tr th div,
.ant-table-container .ant-table-thead tr th div {
  padding-bottom: 0;
}
.ant-table-content .ant-table-thead tr th::before,
.ant-table-container .ant-table-thead tr th::before {
  display: none;
}
.ant-table-content .ant-table-thead tr th:first-of-type,
.ant-table-container .ant-table-thead tr th:first-of-type {
  padding-left: 0rem;
}
.ant-table-content .ant-table-thead tr th:last-of-type,
.ant-table-container .ant-table-thead tr th:last-of-type {
  padding-right: 0rem;
}
.ant-table-content tbody tr:first-of-type td,
.ant-table-container tbody tr:first-of-type td {
  padding-top: 0.5rem;
}
.ant-table-content tbody tr td,
.ant-table-container tbody tr td {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.ant-table-content tbody tr td:first-of-type,
.ant-table-container tbody tr td:first-of-type {
  padding-left: 0rem;
}
.ant-table-content tbody tr td:last-of-type,
.ant-table-container tbody tr td:last-of-type {
  padding-right: 0rem;
}
.ant-table-content tbody tr:last-of-type td,
.ant-table-container tbody tr:last-of-type td {
  border: none;
}
.ant-pagination li.ant-pagination-item-active,
.ant-pagination li:hover {
  border-color: var(--primary-button-color);
}
.ant-pagination li.ant-pagination-item-active a,
.ant-pagination li:hover a {
  color: var(--primary-button-color);
}
.ant-pagination li a {
  text-decoration: none !important;
}
.ant-pagination li:hover button {
  border-color: var(--primary-button-color) !important;
  color: var(--primary-button-color) !important;
}
.ant-tabs-top > .ant-tabs-nav::before,
.ant-tabs-bottom > .ant-tabs-nav::before,
.ant-tabs-top > div > .ant-tabs-nav::before,
.ant-tabs-bottom > div > .ant-tabs-nav::before,
.ant-table-tbody > tr > td {
  border-bottom: 0.063rem solid #C9D3CC;
}
.gyramais-header-content {
  max-width: 1598px;
}
.ant-steps .ant-steps-item-container {
  display: flex;
  align-items: center;
}
.ant-steps .ant-steps-item-icon .ant-steps-icon {
  top: 0px;
}
.ant-steps .ant-steps-item-process .ant-steps-item-icon,
.ant-steps .ant-steps-item-finish .ant-steps-item-icon {
  background-color: var(--primary-button-color);
  border-color: var(--primary-button-color);
}
.ant-steps .ant-steps-item-process .ant-steps-item-icon span,
.ant-steps .ant-steps-item-finish .ant-steps-item-icon span {
  color: var(--primary-button-text-color) !important;
}
.ant-steps .ant-steps-item-wait .ant-steps-item-icon {
  border-color: #C9D3CC;
}
.ant-steps .ant-steps-item-wait .ant-steps-item-icon span {
  color: #C9D3CC !important;
}
.ant-steps .ant-steps-item-icon {
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 768px) {
  .ant-steps .ant-steps-item-icon {
    margin-right: 0rem;
  }
}
.ant-steps .ant-steps-item-icon span {
  font-size: 1.25rem;
  font-weight: 500;
}
.ant-steps .ant-steps-item-finish .ant-steps-item-icon {
  background-color: var(--primary-button-color);
  border-color: var(--primary-button-color);
}
.ant-steps .ant-steps-item-finish .ant-steps-item-icon .ant-steps-icon {
  color: var(--primary-button-text-color);
}
.ant-steps .ant-steps-item-title {
  font-size: 1.125rem;
  font-weight: 400;
  line-height: 1.375rem;
}
@media (max-width: 768px) {
  .ant-steps .ant-steps-item-title {
    display: none;
  }
}
.ant-steps .ant-steps-item-title :hover {
  background-color: var(--primary-color);
}
@media (max-width: 768px) {
  .ant-steps .ant-steps-item-icon:not(:last-of-type)::after {
    position: absolute;
    left: 3.5rem;
    display: block;
    width: 624.938rem;
    height: 0.063rem;
    top: 1.25rem;
    background-color: #C9D3CC !important;
    content: '';
  }
}
.ant-steps .ant-steps-item-title::after {
  top: 0.75rem;
  background-color: #C9D3CC !important;
}
.styles_react-code-input-container__tpiKG {
  margin-right: 0;
  width: 100% !important;
}
.styles_react-code-input__CRulA > input {
  font-family: 'Poppins', sans-serif;
}
.styles_react-code-input__CRulA {
  margin-top: 1.5rem;
}
@media (max-width: 768px) {
  .styles_react-code-input__CRulA {
    margin-left: auto;
    margin-right: auto;
  }
}
.styles_react-code-input__CRulA input {
  width: 4.188rem !important;
  height: 4.188rem !important;
  border: 0.063rem solid rgba(0, 0, 0, 0.2);
  border-radius: 1.25rem !important;
  font-size: 2rem;
  line-height: 2.4rem;
  font-weight: 300;
}
@media (max-width: 768px) {
  .styles_react-code-input__CRulA input {
    width: 3.063rem !important;
    height: 3.063rem !important;
    border-radius: calc(calc(1.25rem * 2) / 3) !important;
  }
}
.styles_react-code-input__CRulA input:not(:first-child):not(:last-child) {
  margin: 0rem 0.375rem;
}
@media (max-width: 768px) {
  .styles_react-code-input__CRulA input:not(:first-child):not(:last-child) {
    margin: 0rem 0.25rem;
  }
}
.styles_react-code-input__CRulA input:first-child {
  margin-right: 0.375rem;
}
@media (max-width: 768px) {
  .styles_react-code-input__CRulA input:first-child {
    margin-right: 0.25rem;
  }
}
.styles_react-code-input__CRulA input:last-child {
  margin-left: 0.375rem;
}
@media (max-width: 768px) {
  .styles_react-code-input__CRulA input:last-child {
    margin-left: 0.25rem;
  }
}
.ant-select-dropdown {
  border-bottom-left-radius: calc(1.25rem / 2);
  border-bottom-right-radius: calc(1.25rem / 2);
  z-index: 999999;
}
.global-footer-wrapper {
  width: 100%;
  position: sticky;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 8rem;
  bottom: 0;
  left: 0;
  border-top: 0.063rem solid #00000026;
  background-color: #ffffff;
}
.global-footer-wrapper > * {
  margin: auto !important;
  width: 100%;
  max-width: 1598px;
}
@media (max-width: 1600px) {
  .global-footer-wrapper {
    padding: 0rem 5.625rem;
  }
}
@media (max-width: 1200px) {
  .global-footer-wrapper {
    padding: 0rem 3.75rem;
  }
}
@media (max-width: 768px) {
  .global-footer-wrapper {
    padding: 0rem 1rem;
  }
}
@media (max-width: 768px) {
  .global-footer-wrapper {
    padding: 0rem 1rem !important;
    justify-content: center;
  }
  .global-footer-wrapper .gyramais-btn {
    width: 100% !important;
  }
}
.global-footer-wrapper .footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.global-footer-wrapper .footer.no-back-btn {
  justify-content: flex-end;
}
@media (max-width: 768px) {
  .global-footer-wrapper .footer {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .global-footer-wrapper .footer .gyramais-btn {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .global-footer-wrapper .footer .gyramais-btn-link {
    padding-left: 0rem;
    width: fit-content !important;
  }
}
@media (max-width: 768px) {
  .ant-form-item-explain {
    text-align: center;
    margin-top: 0.25rem;
  }
}
.ant-tooltip {
  max-width: 28.125rem;
}
.ant-tooltip .ant-tooltip-inner {
  border-radius: calc(1.25rem / 2);
}
@media (max-width: 768px) {
  .ant-tooltip {
    max-width: 21.875rem;
  }
}
.gyra-custom-scroll {
  scroll-behavior: smooth;
  /* Track */
  /* Handle */
}
.gyra-custom-scroll::-webkit-scrollbar {
  width: 10px;
}
.gyra-custom-scroll::-webkit-scrollbar-track {
  background: #eee;
  border-radius: 10px;
}
.gyra-custom-scroll::-webkit-scrollbar-thumb {
  background: var(--primary-color);
  border-radius: 10px;
}
.divider-without-margin {
  margin-top: 0;
}
.link-in-line-text {
  margin: 0 4px;
}
textarea.gyramais-input {
  padding: 1rem 1.5rem !important;
  font-size: 1rem !important;
}
.ant-radio .ant-radio-inner::after {
  background-color: var(--primary-button-color) !important;
}
.ant-radio:hover .ant-radio-inner {
  border-color: var(--primary-button-color) !important;
}
.ant-radio.ant-radio-checked .ant-radio-inner {
  border-color: var(--primary-button-color) !important;
}
.pulse-animation {
  animation: pulse 2s infinite;
}
.warning-card {
  animation: warning 2s infinite;
}
@keyframes warning {
  0% {
    box-shadow: 0 0 2px #f3a8127c;
  }
  40% {
    box-shadow: 0 0 8px 4px #f3a8127c;
  }
  80% {
    box-shadow: 0 0 2px #f3a8127c;
  }
}
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(3, 115, 140, 0);
  }
  70% {
    box-shadow: 0 0 1rem 0.375rem var(--primary-button-color);
  }
  100% {
    box-shadow: 0 0 0 0 var(--primary-button-color);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.less"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AACA;;CAEC;AAGD;EACE,YAAA;EACA,SAAA;EACA,gCAAA;AADF;AAiBA;;;;;;;EAOE,cAAA;AAfF;AAkBA;EACE,mBAAA;EACA,gBAAA;EACA,oBAAA;EAEA,qBAAA;AAjBF;AAmBE;EAAA;IACE,iBAAA;IACA,mBAAA;EAhBF;AACF;AAmBA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EAEA,qBAAA;AAlBF;AAoBE;EAAA;IACE,iBAAA;IACA,mBAAA;EAjBF;AACF;AAoBA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,qBAAA;AAnBF;AAqBE;EAAA;IACE,kBAAA;IACA,mBAAA;EAlBF;AACF;AAqBA;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,qBAAA;AApBF;AAsBE;EAAA;IACE,kBAAA;IACA,mBAAA;EAnBF;AACF;AAsBA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AApBF;AAsBE;EAAA;IACE,eAAA;IACA,mBAAA;EAnBF;AACF;AAsBA;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;AApBF;AAsBE;EAAA;IACE,eAAA;IACA,iBAAA;EAnBF;AACF;AAsBA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;AApBF;AAuBA;EACE,cAAA;EACA,gBAAA;AArBF;AAuBE;EACE,2BAAA;AArBJ;AAyBA;EACE,+BAAA;EACA,0BAAA;EACA,gBAAA;AAvBF;AAyBE;EACE,+BAAA;AAvBJ;AA2BA;EACE,cAAA;EACA,gBAAA;AAzBF;AA4BA;EACE,sCAAA;AA1BF;AA6BA;EACE,6CAAA;AA3BF;AA8BA;EACE,0CAAA;AA5BF;AA+BA;EACE,mBAAA;AA7BF;AAgCA;EACE,kBAAA;AA9BF;AAiCA;EACE,gBAAA;AA/BF;AAkCA;EACE,iBAAA;AAhCF;AAmCA;EACE,cAAA;AAjCF;AAoCA;EACE,cAAA;AAlCF;AAqCA;EACE,gCAAA;AAnCF;AAsCA;EACE,2BAAA;AApCF;AAuCA;EACE,2BAAA;AArCF;AAwCA;EACE,0BAAA;AAtCF;AAyCA;EACE,uCAAA;EACA,gBAAA;AAvCF;AA0CA;EACE,yCAAA;EACA,gBAAA;AAxCF;AA2CA;EACE,0BAAA;AAzCF;AA4CA;EACE,gBAAA;AA1CF;AA6CA;EACE,oBAAA;AA3CF;AA8CA;EACE,qBAAA;AA5CF;AACA;;CAEC;AACD;;CAEC;AAiDD;EACE,yBAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;AA/CF;AA2CA;EAOI,UAAA;EACA,SAAA;AA/CJ;AAkDE;EAAA;IACE,kBAAA;EA/CF;AACF;AAiDE;EAAA;IACE,eAAA;EA9CF;AACF;AAkDA;EACE,mBAAA;AAhDF;AA+CA;EAII,gBAAA;EACA,oDAAA;EACA,8BAAA;EACA,sBAAA;AAhDJ;AAyCA;EAUM,YAAA;AAhDN;AAsCA;EAcM,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AAjDN;AAgCA;EAqBM,gBAAA;EACA,eAAA;EACA,qBAAA;AAlDN;AA2DI;EAAA;IACE,qBAAA;EAxDJ;AACF;AACA;;CAEC;AACD;;CAEC;AA+DC;EAEI,6DAAA;EACA,UAAA;AA9DN;AA0DA;EASI,qBAAA;EACA,gBAAA;AAhEJ;AAoEE;EAEI,oDAAA;EACA,wDAAA;AAnEN;AAuEE;EACE,yBAAA;AArEJ;AA+CA;EA0BI,yCAAA;AAtEJ;AA0EA;EAEI,yCAAA;AAzEJ;AA6EA;EAEI,2BAAA;EACA,UAAA;AA5EJ;AAgFA;EACE,aAAA;AA9EF;AAiFA;EACE,aAAA;AA/EF;AAkFA;EACE,YAAA;AAhFF;AAmFA;EACE,oCAAA;AAjFF;AAoFA;EACE,gCAAA;EACA,oDAAA;AAlFF;AAgFA;EAKI,qBAAA;AAlFJ;AA6EA;EASI,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AAnFJ;AAuFA;EACE,mBAAA;EACA,oBAAA;AArFF;AAmFA;EAKI,oBAAA;AArFJ;AAwFE;EAAA;IACE,oBAAA;EArFF;AACF;AAwFA;EACE,UAAA;AAtFF;AAyFA;EACE,aAAA;EACA,8BAAA;EACA,oBAAA;AAvFF;AAoFA;EAMI,oBAAA;AAvFJ;AAiFA;EAUI,cAAA;AAxFJ;AA0FI;EACE,eAAA;AAxFN;AA4FE;EAAA;IACE,oBAAA;EAzFF;AACF;AA4FA;EACE,yBAAA;AA1FF;AA6FA;EACE,eAAA;EACA,qCAAA;AA3FF;AA8FA;EAEI,mBAAA;AA7FJ;AAkGM;EAAA;IACE,qBAAA;EA/FN;AACF;AAiGM;EAAA;IACE,sBAAA;EA9FN;AACF;AAoGA;EACE,uBAAA;AAlGF;AAqGA;EACE,wDAAA;AAnGF;AAsGA;EACE,wBAAA;AApGF;AAuGA;EAEI,eAAA;EACA,qBAAA;EACA,gBAAA;AAtGJ;AAyGM;EAEI,cAAA;AAxGV;AA6GI;EAEI,cAAA;AA5GR;AA4FA;EAsBI,0BAAA;EACA,kDAAA;AA/GJ;AAmHA;EACE,uBAAA;AAjHF;AAgHA;EAII,gBAAA;EACA,eAAA;AAjHJ;AAqHA;EACE,oCAAA;EACA,gCAAA;EACA,iCAAA;AAnHF;AAgHA;EAMI,YAAA;AAnHJ;AA6GA;EAUI,yBAAA;AApHJ;AAwHA;EACE,eAAA;AAtHF;AA0HA;;EAEE,0BAAA;AAxHF;AAsHA;;EAKI,iBAAA;EACA,oBAAA;AAvHJ;AAiHA;;EAYQ,4BAAA;EACA,uBAAA;EACA,6CAAA;EACA,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,mBAAA;AAzHR;AAuGA;;EAsBY,8BAAA;EACA,mBAAA;AAzHZ;AAkGA;;EA4BU,aAAA;AA1HV;AA8FA;;EAgCU,iBAAA;AA1HV;AA6HQ;;EACE,aAAA;AA1HV;AA6HQ;;EACE,kBAAA;AA1HV;AA6HQ;;EACE,mBAAA;AA1HV;AA8EA;;EAqDQ,mBAAA;AA/HR;AA0EA;;EA2DQ,iBAAA;EACA,oBAAA;AAjIR;AAmIQ;;EACE,kBAAA;AAhIV;AAmIQ;;EACE,mBAAA;AAhIV;AA6DA;;EA0EQ,YAAA;AAnIR;AA0II;;EACE,yCAAA;AAvIN;AAsII;;EAGI,kCAAA;AArIR;AAgIA;EASM,gCAAA;AAtIN;AAyII;EAEI,oDAAA;EACA,6CAAA;AAxIR;AAgJA;;;;;EAKE,qCAAA;AA9IF;AAiJA;EACE,iBAAA;AA/IF;AAmJA;EAEI,aAAA;EACA,mBAAA;AAlJJ;AA+IA;EAQM,QAAA;AApJN;AA4IA;;EAeM,6CAAA;EACA,yCAAA;AAvJN;AAuIA;;EAmBQ,kDAAA;AAtJR;AAmIA;EA0BM,qBAAA;AA1JN;AAgIA;EA6BQ,yBAAA;AA1JR;AA6HA;EAmCI,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA7JJ;AA+JI;EAAA;IACE,kBAAA;EA5JJ;AACF;AAiHA;EA8CM,kBAAA;EACA,gBAAA;AA5JN;AA6GA;EAoDI,6CAAA;EACA,yCAAA;AA9JJ;AAyGA;EAwDM,uCAAA;AA9JN;AAsGA;EA6DI,mBAAA;EACA,gBAAA;EACA,qBAAA;AAhKJ;AAkKI;EAAA;IACE,aAAA;EA/JJ;AACF;AA4FA;EAsEM,sCAAA;AA/JN;AAsKE;EAAA;IAEI,kBAAA;IACA,YAAA;IACA,cAAA;IACA,iBAAA;IACA,gBAAA;IACA,YAAA;IACA,oCAAA;IACA,WAAA;EApKJ;AACF;AA6EA;EA4FI,YAAA;EACA,oCAAA;AAtKJ;AA2KA;EACE,eAAA;EACA,sBAAA;AAzKF;AA4KA;EACE,kCAAA;AA1KF;AA6KA;EACE,kBAAA;AA3KF;AA6KE;EAAA;IAEE,iBAAA;IACA,kBAAA;EA3KF;AACF;AAoKA;EAUI,0BAAA;EACA,2BAAA;EACA,yCAAA;EACA,iCAAA;EAEA,eAAA;EACA,mBAAA;EACA,gBAAA;AA5KJ;AA8KI;EAAA;IACE,0BAAA;IACA,2BAAA;IACA,qDAAA;EA3KJ;AACF;AAoJA;EA2BI,qBAAA;AA5KJ;AA8KI;EAAA;IACE,oBAAA;EA3KJ;AACF;AA4IA;EAmCI,sBAAA;AA5KJ;AA8KI;EAAA;IACE,qBAAA;EA3KJ;AACF;AAoIA;EA2CI,qBAAA;AA5KJ;AA8KI;EAAA;IACE,oBAAA;EA3KJ;AACF;AAgLA;EACE,4CAAA;EACA,6CAAA;EAIA,eAAA;AAjLF;AAsLA;EAUE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,SAAA;EACA,OAAA;EACA,oCAAA;EACA,yBAAA;AA7LF;AA0KA;EAKI,uBAAA;EACA,WAAA;EACA,iBAAA;AA5KJ;AA0LE;EAAA;IACE,sBAAA;EAvLF;AACF;AAyLE;EAAA;IACE,qBAAA;EAtLF;AACF;AAwLE;EAAA;IACE,kBAAA;EArLF;AACF;AAuLE;EAAA;IACE,6BAAA;IACA,uBAAA;EApLF;EAkLA;IAKI,sBAAA;EApLJ;AACF;AA6IA;EA2CI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;AArLJ;AAuLI;EACE,yBAAA;AArLN;AAwLI;EAAA;IACE,iBAAA;IACA,oBAAA;EArLJ;EAmLE;IAKI,kBAAA;IACA,mBAAA;EArLN;EA+KE;IAUI,kBAAA;IACA,6BAAA;EAtLN;AACF;AA6LA;EACE;IACE,kBAAA;IACA,mBAAA;EA3LF;AACF;AA+LA;EACE,oBAAA;AA7LF;AA4LA;EAII,gCAAA;AA7LJ;AAgME;EAAA;IACE,oBAAA;EA7LF;AACF;AAgMA;EACE,uBAAA;EA9LA,UAAU;EACV,WAAW;AACb;AA8LE;EACE,WAAA;AA5LJ;AAgME;EACE,gBAAA;EACA,mBAAA;AA9LJ;AAkME;EACE,gCAAA;EACA,mBAAA;AAhMJ;AAoMA;EACE,aAAA;AAlMF;AAqMA;EACE,aAAA;AAnMF;AAsMA;EACE,+BAAA;EACA,0BAAA;AApMF;AA0MI;EACE,wDAAA;AAxMN;AA4ME;EAEI,oDAAA;AA3MN;AA+ME;EAEI,oDAAA;AA9MN;AAmNA;EACE,4BAAA;AAjNF;AAoNA;EACE,8BAAA;AAlNF;AAuNA;EACE;IACE,6BAAA;EArNF;EAwNA;IACE,iCAAA;EAtNF;EAyNA;IACE,6BAAA;EAvNF;AACF;AA0NA;EACE;IAEE,wCAAA;EAzNF;EA4NA;IAEE,yDAAA;EA3NF;EA8NA;IAEE,+CAAA;EA7NF;AACF","sourcesContent":["body {\n  font-size: 0.875rem;\n}\n\n/*\n  ------------------------------------------------- INICIO DOS ELEMENTOS PADRÕES -------------------------------------------------\n*/\n\nhr {\n  opacity: 0.2;\n  border: 0;\n  border-top: .063rem solid black;\n}\n\n// FONT-SIZE { desktop size -> mobile size }\n// h1 { 38px -> 24px }\n// h2 { 32px -> 24px }\n// h3 { 28px -> 20px }\n// h4 { 24px -> 20px }\n// h5 { 20px -> 16px }\n// h6 { 18px -> 16px }\n// p { 16px -> 16px }\n\n// FONT-WEIGHT\n// b { 400 }\n// strong { 700 } \n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np {\n  color: #000000;\n}\n\nh1 {\n  font-size: 2.375rem; // 38px\n  font-weight: 300;\n  line-height: 2.380rem;\n\n  white-space: pre-line;\n\n  @media(max-width: @md-screen) {\n    font-size: 1.5rem; // 24px\n    line-height: 1.6rem;\n  }\n}\n\nh2 {\n  font-size: 2rem; // 32px\n  font-weight: 300;\n  line-height: 2.5rem;\n\n  white-space: pre-line;\n\n  @media(max-width: @md-screen) {\n    font-size: 1.5rem; // 24px\n    line-height: 1.6rem;\n  }\n}\n\nh3 {\n  font-size: 1.75rem; // 28px\n  font-weight: 300;\n  line-height: 2.1rem;\n\n  white-space: pre-line;\n\n  @media(max-width: @md-screen) {\n    font-size: 1.25rem; // 20px\n    line-height: 1.3rem;\n  }\n}\n\nh4 {\n  font-size: 1.5rem; // 24px\n  font-weight: 300;\n  line-height: 1.8rem;\n\n  white-space: pre-line;\n\n  @media(max-width: @md-screen) {\n    font-size: 1.25rem; // 20px\n    line-height: 1.5rem;\n  }\n}\n\nh5 {\n  font-size: 1.25rem; // 20px\n  font-weight: 300;\n  line-height: 1.5rem;\n\n  @media(max-width: @md-screen) {\n    font-size: 1rem; // 16px\n    line-height: 1.3rem;\n  }\n}\n\nh6 {\n  font-size: 1.125rem; // 18px\n  font-weight: 300;\n  line-height: 1.3rem;\n\n  @media(max-width: @md-screen) {\n    font-size: 1rem; // 16px\n    line-height: 1rem;\n  }\n}\n\np {\n  font-size: 1rem; // 16px\n  font-weight: 200;\n  line-height: 1.375rem;\n}\n\nb {\n  color: #000000;\n  font-weight: 400;\n\n  &.weight-500 {\n    font-weight: 500 !important;\n  }\n}\n\na {\n  color: var(--link-button-color);\n  text-decoration: underline;\n  font-weight: 500;\n\n  &:hover {\n    color: var(--link-button-color);\n  }\n}\n\nstrong {\n  color: #000000;\n  font-weight: 600;\n}\n\n.primary-text {\n  color: var(--primary-color) !important;\n}\n\n.secondary-text {\n  color: var(--primary-button-color) !important;\n}\n\n.link-text {\n  color: var(--link-button-color) !important;\n}\n\n.justified-text {\n  text-align: justify;\n}\n\n.center-text {\n  text-align: center;\n}\n\n.left-text {\n  text-align: left;\n}\n\n.right-text {\n  text-align: right;\n}\n\n.white-text {\n  color: #ffffff;\n}\n\n.gray-text {\n  color: #C9D3CC;\n}\n\n.white-label-text {\n  color: var(--primary-text-color)\n}\n\n.success-text {\n  color: var(--success-color);\n}\n\n.warning-text {\n  color: var(--warning-color);\n}\n\n.danger-text {\n  color: var(--danger-color);\n}\n\n.primary-button-text {\n  color: var(--primary-button-text-color);\n  font-weight: 500;\n}\n\n.secondary-button-text {\n  color: var(--secondary-button-text-color);\n  font-weight: 500;\n}\n\n.underline {\n  text-decoration: underline;\n}\n\n.no-margin-bottom {\n  margin-bottom: 0;\n}\n\n.no-margin {\n  margin: 0 !important;\n}\n\n.no-padding {\n  padding: 0 !important;\n}\n\n/*\n  ------------------------------------------------- FIM DOS ELEMENTOS PADRÕES -------------------------------------------------\n*/\n\n/*\n  ------------------------------------------------- INICIO DOS ELEMENTOS ANTD -------------------------------------------------\n*/\n// Card padrão\n.ant-card {\n  border: 1px solid #C9D3CC;\n  box-shadow: none;\n  border-radius: @border-radius;\n  padding: 2.5rem 5rem;\n\n  .ant-card-body {\n    padding: 0;\n    margin: 0;\n  }\n\n  @media(max-width: @lg-screen) {\n    padding: 2rem 3rem;\n  }\n\n  @media(max-width: @md-screen) {\n    padding: 1.5rem;\n  }\n}\n\n// Notificação padrão\n.ant-notification {\n  z-index: 5000000001;\n\n  .ant-notification-notice {\n    width: 28.625rem;\n    box-shadow: 0rem .25rem .25rem rgba(0, 0, 0, 0.05);\n    border: .063rem solid #C9D3CC;\n    border-radius: @border-radius;\n\n    .ant-notification-close-icon {\n      color: black\n    }\n\n    .ant-notification-notice-message {\n      font-weight: 300;\n      color: #000000;\n      font-size: 1.125rem;\n      line-height: 1.5rem;\n    }\n\n    .ant-notification-notice-description {\n      font-weight: 400;\n      font-size: 1rem;\n      line-height: 1.375rem;\n    }\n  }\n}\n\n// Form padrão\n.ant-form {\n  .ant-form-item {\n\n    @media(max-width: @md-screen) {\n      margin-bottom: 1.5rem;\n    }\n  }\n}\n\n/*\n------------------------------------------------- FIM DOS ELEMENTOS ANTD -------------------------------------------------\n*/\n\n/*\n------------------------------------------------- INÍCIO DA TERRA DOS SEM LEI -------------------------------------------------\n*/\n\n.ant-checkbox {\n  &:hover {\n    span {\n      border: .063rem solid var(--primary-button-color) !important;\n      opacity: 1;\n    }\n  }\n\n  +span {\n    padding-left: 0.71rem;\n    padding-right: 0;\n  }\n\n\n  &.ant-checkbox-checked {\n    .ant-checkbox-inner {\n      border-color: var(--primary-button-color) !important;\n      background-color: var(--primary-button-color) !important;\n    }\n  }\n\n  &::after {\n    border-color: transparent;\n  }\n\n  .ant-checkbox-input:focus+.ant-checkbox-inner {\n    border-color: var(--primary-button-color);\n  }\n}\n\n.ant-checkbox-wrapper:hover {\n  .ant-checkbox-inner {\n    border-color: var(--primary-button-color);\n  }\n}\n\n.ant-form-item-label {\n  label {\n    color: var(--primary-color);\n    opacity: 1;\n  }\n}\n\n.ant-form-item-label>label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {\n  content: none;\n}\n\n.ant-form-item-label>label::after {\n  content: none;\n}\n\n#root {\n  height: 100%;\n}\n\nsection.ant-layout {\n  background-color: #ffffff !important;\n}\n\n.ant-popover-inner {\n  border-radius: calc(@border-radius / 2);\n  box-shadow: 0rem .5rem .938rem rgba(0, 0, 0, 0.15);\n\n  .ant-popover-inner-content {\n    padding: 0 !important;\n  }\n\n  .ant-menu-title-content {\n    font-weight: 500;\n    font-size: 1rem;\n    line-height: 1.2rem;\n    color: #003930;\n  }\n}\n\n.ant-drawer-header {\n  border-bottom: none;\n  padding: .5rem 4rem;\n\n  .close-icon {\n    margin-right: .5rem;\n  }\n\n  @media(max-width: @md-screen) {\n    padding: .5rem 1rem;\n  }\n}\n\n.ant-drawer-body {\n  padding: 0;\n}\n\n.ant-drawer-footer {\n  display: flex;\n  justify-content: space-between;\n  padding: .5rem 4rem;\n\n  .back-icon {\n    margin-right: .5rem;\n  }\n\n  .gyramais-btn {\n    min-width: 30%;\n\n    &.gyramais-btn-link {\n      min-width: 1rem;\n    }\n  }\n\n  @media(max-width: @md-screen) {\n    padding: .5rem 1rem;\n  }\n}\n\n.ant-input-number {\n  padding: .25rem .688rem;\n}\n\na:hover {\n  cursor: pointer;\n  text-decoration: underline !important;\n}\n\n.ant-drawer {\n  .ant-drawer-content-wrapper {\n    max-width: 66.25rem;\n  }\n\n  &:not(.mobile-menu) {\n    .ant-drawer-content-wrapper {\n      @media(min-width: 150rem) {\n        width: 50% !important;\n      }\n\n      @media(max-width: @md-screen) {\n        width: 100% !important;\n      }\n    }\n  }\n}\n\n\n.ant-checkbox-inner {\n  border-color: #00000044;\n}\n\n.ant-checkbox-checked .ant-checkbox-inner {\n  background-color: var(--primary-button-color) !important;\n}\n\n.react-share__ShareButton {\n  outline: none !important;\n}\n\n.ant-tabs-nav-list {\n  .ant-tabs-tab {\n    font-size: 1rem;\n    line-height: 1.375rem;\n    font-weight: 400;\n\n    &:not(.ant-tabs-tab-disabled) {\n      &:hover {\n        .ant-tabs-tab-btn {\n          color: #000000;\n        }\n      }\n    }\n\n    &.ant-tabs-tab-active {\n      .ant-tabs-tab-btn {\n        color: #000000;\n      }\n    }\n  }\n\n  .ant-tabs-ink-bar {\n    height: .25rem !important;\n    background: var(--primary-button-color) !important;\n  }\n}\n\n.ant-alert {\n  border-radius: 0.625rem;\n\n  .ant-alert-message {\n    font-weight: 400;\n    font-size: 1rem;\n  }\n}\n\n.grey-alert {\n  background-color: #f0f0f0 !important;\n  border-color: #f0f0f0 !important;\n  margin-bottom: .75rem !important;\n\n  span.ant-alert-message {\n    opacity: 0.5;\n  }\n\n  .alert-icon {\n    color: #000000 !important;\n  }\n}\n\n.ant-image {\n  cursor: pointer;\n}\n\n// novo estilos de table\n.ant-table-content,\n.ant-table-container {\n  margin-right: 0 !important;\n\n  td {\n    font-size: 1.5rem;\n    line-height: 1.75rem;\n  }\n\n  .ant-table-thead {\n    tr {\n      th {\n        background: white !important;\n        background-color: white;\n        color: var(--primary-button-color) !important;\n        border: none;\n        padding-bottom: 0;\n        font-weight: normal !important;\n        font-size: 1.125rem;\n\n        .ant-table-column-sorters {\n          >span:first-of-type {\n            font-weight: normal !important;\n            font-size: 1.125rem;\n          }\n        }\n\n        .ant-table-column-sorter {\n          display: flex\n        }\n\n        div {\n          padding-bottom: 0;\n        }\n\n        &::before {\n          display: none;\n        }\n\n        &:first-of-type {\n          padding-left: 0rem;\n        }\n\n        &:last-of-type {\n          padding-right: 0rem;\n        }\n      }\n    }\n  }\n\n  tbody {\n    tr:first-of-type {\n      td {\n        padding-top: 0.5rem;\n      }\n    }\n\n    tr {\n      td {\n        padding-top: 1rem;\n        padding-bottom: 1rem;\n\n        &:first-of-type {\n          padding-left: 0rem;\n        }\n\n        &:last-of-type {\n          padding-right: 0rem;\n        }\n      }\n    }\n\n    tr:last-of-type {\n      td {\n        border: none;\n      }\n    }\n  }\n}\n.ant-pagination{\n  li{\n    &.ant-pagination-item-active, &:hover{\n      border-color: var(--primary-button-color);\n      a{\n        color: var(--primary-button-color);\n      }\n    }\n    a{\n      text-decoration: none !important;\n    }\n    \n    &:hover{\n      button{\n        border-color: var(--primary-button-color) !important;\n        color: var(--primary-button-color) !important;\n\n      }\n    }\n  }\n}\n\n// linha divisória do antd\n.ant-tabs-top>.ant-tabs-nav::before,\n.ant-tabs-bottom>.ant-tabs-nav::before,\n.ant-tabs-top>div>.ant-tabs-nav::before,\n.ant-tabs-bottom>div>.ant-tabs-nav::before,\n.ant-table-tbody>tr>td {\n  border-bottom: .063rem solid #C9D3CC;\n}\n\n.gyramais-header-content {\n  max-width: @content-max-width;\n}\n\n// novo style do componente step\n.ant-steps {\n  .ant-steps-item-container {\n    display: flex;\n    align-items: center;\n  }\n\n  .ant-steps-item-icon {\n    .ant-steps-icon {\n      top: 0px;\n    }\n  }\n\n  .ant-steps-item-process,\n  .ant-steps-item-finish {\n    .ant-steps-item-icon {\n      background-color: var(--primary-button-color);\n      border-color: var(--primary-button-color);\n\n      span {\n        color: var(--primary-button-text-color) !important;\n      }\n    }\n  }\n\n  .ant-steps-item-wait {\n    .ant-steps-item-icon {\n      border-color: #C9D3CC;\n\n      span {\n        color: #C9D3CC !important;\n      }\n    }\n  }\n\n  .ant-steps-item-icon {\n    width: 2.5rem;\n    height: 2.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    @media(max-width: @md-screen) {\n      margin-right: 0rem;\n    }\n\n    span {\n      font-size: 1.25rem;\n      font-weight: 500;\n    }\n  }\n\n  .ant-steps-item-finish .ant-steps-item-icon {\n    background-color: var(--primary-button-color);\n    border-color: var(--primary-button-color);\n\n    .ant-steps-icon {\n      color: var(--primary-button-text-color);\n    }\n  }\n\n  .ant-steps-item-title {\n    font-size: 1.125rem;\n    font-weight: 400;\n    line-height: 1.375rem;\n\n    @media(max-width: @md-screen) {\n      display: none;\n    }\n\n    :hover {\n      background-color: var(--primary-color);\n    }\n  }\n\n  // manulmente trocando a linha divisória para\n  // aparecer no icone ao invés do title\n  // pois o mesmo não irá aparecer em mobile\n  @media(max-width: @md-screen) {\n    .ant-steps-item-icon:not(:last-of-type)::after {\n      position: absolute;\n      left: 3.5rem;\n      display: block;\n      width: 624.938rem;\n      height: .063rem;\n      top: 1.25rem;\n      background-color: #C9D3CC !important;\n      content: '';\n    }\n  }\n\n  // linha entre os steps\n  .ant-steps-item-title::after {\n    top: .75rem;\n    background-color: #C9D3CC !important;\n  }\n}\n\n// styles do react code\n.styles_react-code-input-container__tpiKG {\n  margin-right: 0;\n  width: 100% !important;\n}\n\n.styles_react-code-input__CRulA>input {\n  font-family: 'Poppins', sans-serif;\n}\n\n.styles_react-code-input__CRulA {\n  margin-top: 1.5rem;\n\n  @media(max-width: @md-screen) {\n    // centralizar no meio quando em mobile\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  input {\n    width: 4.188rem !important;\n    height: 4.188rem !important;\n    border: .063rem solid rgba(0, 0, 0, 0.2);\n    border-radius: @border-radius !important;\n\n    font-size: 2rem;\n    line-height: 2.4rem;\n    font-weight: 300;\n\n    @media(max-width: @md-screen) {\n      width: 3.063rem !important;\n      height: 3.063rem !important;\n      border-radius: calc(calc(@border-radius * 2) / 3) !important;\n    }\n  }\n\n  input:not(:first-child):not(:last-child) {\n    margin: 0rem .375rem;\n\n    @media(max-width: @md-screen) {\n      margin: 0rem .25rem;\n    }\n  }\n\n  input:first-child {\n    margin-right: .375rem;\n\n    @media(max-width: @md-screen) {\n      margin-right: .25rem;\n    }\n  }\n\n  input:last-child {\n    margin-left: .375rem;\n\n    @media(max-width: @md-screen) {\n      margin-left: .25rem;\n    }\n  }\n}\n\n// border radius no dropdown menu\n.ant-select-dropdown {\n  border-bottom-left-radius: calc(@border-radius / 2);\n  border-bottom-right-radius: calc(@border-radius / 2);\n\n\n  // por algum motivo essa merda ta ficando atrás dos modais\n  z-index: 999999\n}\n\n// wrapper do footer global\n// aquele que se expande pelo comprimento da tela inteiro\n.global-footer-wrapper {\n  border-top: .063rem solid #00000026;\n  background-color: #ffffff;\n\n  >* {\n    margin: auto !important;\n    width: 100%;\n    max-width: @content-max-width;\n  }\n\n  width: 100%;\n  position: sticky;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 0 8rem;\n  bottom: 0;\n  left: 0;\n  border-top: .063rem solid #00000026;\n  background-color: #ffffff;\n\n  @media(max-width: @xxl-screen) {\n    padding: 0rem 5.625rem;\n  }\n\n  @media(max-width: @xl-screen) {\n    padding: 0rem 3.75rem;\n  }\n\n  @media(max-width: @md-screen) {\n    padding: 0rem 1rem;\n  }\n\n  @media(max-width: @md-screen) {\n    padding: 0rem 1rem !important;\n    justify-content: center;\n\n    .gyramais-btn {\n      width: 100% !important;\n    }\n  }\n\n  .footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n\n    &.no-back-btn {\n      justify-content: flex-end;\n    }\n\n    @media(max-width: @md-screen) {\n      padding-top: 1rem;\n      padding-bottom: 1rem;\n\n      .gyramais-btn {\n        padding-left: 1rem;\n        padding-right: 1rem;\n      }\n\n      .gyramais-btn-link {\n        padding-left: 0rem;\n        width: fit-content !important;\n      }\n    }\n  }\n\n}\n\n// centraliza erro de input no mobile\n@media(max-width: @md-screen) {\n  .ant-form-item-explain {\n    text-align: center;\n    margin-top: .25rem;\n  }\n}\n\n// novo styles de tooltip\n.ant-tooltip {\n  max-width: 28.125rem;\n\n  .ant-tooltip-inner {\n    border-radius: calc(@border-radius / 2);\n  }\n\n  @media(max-width: 768px) {\n    max-width: 21.875rem;\n  }\n}\n\n.gyra-custom-scroll {\n  scroll-behavior: smooth;\n\n  &::-webkit-scrollbar {\n    width: 10px;\n  }\n\n  /* Track */\n  &::-webkit-scrollbar-track {\n    background: #eee;\n    border-radius: 10px;\n  }\n\n  /* Handle */\n  &::-webkit-scrollbar-thumb {\n    background: var(--primary-color);\n    border-radius: 10px;\n  }\n}\n\n.divider-without-margin {\n  margin-top: 0;\n}\n\n.link-in-line-text {\n  margin: 0 4px;\n}\n\ntextarea.gyramais-input {\n  padding: 1rem 1.5rem !important;\n  font-size: 1rem !important;\n}\n\n.ant-radio {\n\n  .ant-radio-inner {\n    &::after {\n      background-color: var(--primary-button-color) !important;\n    }\n  }\n\n  &:hover {\n    .ant-radio-inner {\n      border-color: var(--primary-button-color) !important;\n    }\n  }\n\n  &.ant-radio-checked {\n    .ant-radio-inner {\n      border-color: var(--primary-button-color) !important;\n    }\n  }\n}\n\n.pulse-animation {\n  animation: pulse 2s infinite;\n}\n\n.warning-card {\n  animation: warning 2s infinite;\n}\n\n// -------------------------------------- ANIMAÇÕES ------------------------------------------\n\n@keyframes warning {\n  0% {\n    box-shadow: 0 0 2px #f3a8127c;\n  }\n\n  40% {\n    box-shadow: 0 0 8px 4px #f3a8127c;\n  }\n\n  80% {\n    box-shadow: 0 0 2px #f3a8127c;\n  }\n}\n\n@keyframes pulse {\n  0% {\n    // transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(3, 115, 140, 0);\n  }\n\n  70% {\n    // transform: scale(1);\n    box-shadow: 0 0 1rem .375rem var(--primary-button-color);\n  }\n\n  100% {\n    // transform: scale(0.95);\n    box-shadow: 0 0 0 0 var(--primary-button-color);\n  }\n}\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
